<template>
  <v-dialog v-model="isOpen"
    persistent
    scrollable
    content-class="user-pref-dialog">
    <v-card>
      <v-toolbar class="escalon-dialog-header" height="35">
        <img
          class="modal-axis-logo mr-2"
          :src="require('../../assets/' + coloredLogo)" />
        <span class="modal-title">{{modalTitle}}</span>
        <v-spacer />
        <v-btn text @click="clearDataAndClose()">
          <v-avatar size="20" class="mr-2">
            <img :src="require('../../assets/' + coloredAssetUrls.close)" />
          </v-avatar>Close
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid grid-list-md>
          <v-layout wrap>
            <v-flex md12>
              <div class="error">{{error}}</div>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">First Name</label>
              </div>
              <v-text-field
                class="inputField"
                type="text"
                name="physician.fName"
                v-model="physician.fName"
                solo
                v-validate="{ required: true }"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Last Name</label>
              </div>
              <v-text-field
                class="inputField"
                type="text"
                name="physician.lName"
                v-model="physician.lName"
                solo
                v-validate="{ required: true }"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Status</label>
              </div>
              <select-with-button
                class="inputField"
                v-model="physician.phyStatus"
                :items="ISSELECTED"
                name="physician.phyStatus"
                v-validate="{ required: true }"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Level</label>
              </div>
              <select-with-button
                class="inputField"
                v-model="physician.phyLevel"
                :items="PHYSICIAN_LEVEL"
                name="physician.phyLevel"
                v-validate="{ required: true }"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Associated User</label>
              </div>
              <select-with-button
                class="inputField"
                v-model="physician.associatedUser"
                :items="sortedUsers"
                item-value="srNo"
                item-text="name"
                name="physician.associatedUser"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="clearDataAndClose()" class="modal-cta">Cancel</v-btn>
        <v-btn text @click="submit" class="modal-cta">Save Changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  PHYSICIAN_LEVEL,
  ISSELECTED
} from "../../config/config.js";
import selectWithButton from "../../components/controls/SelectWithButton";

export default {
  name: "addPhysician",
  components: {
    selectWithButton
  },
  props: {
    isOpen: Boolean,
    isUpdate: Boolean,
    physician: Object,
    users: Array
  },
  data() {
    return {
      PHYSICIAN_LEVEL: PHYSICIAN_LEVEL,
      ISSELECTED: ISSELECTED,
      error: null
    };
  },
  computed: {
    modalTitle() {
      return (this.isUpdate ? "Update Physician" : "Add Physician");
    },
    sortedUsers() {
      return [...this.users]
        .sort((a, b) => {
          let nA = a.name.toLowerCase(),
            nB = b.name.toLowerCase();
          return nA < nB ? -1 : nA > nB ? 1 : 0;
        });
    }
  },
  methods: {
    clearDataAndClose(){
      this.error = null;
      this.$emit("close");
    },
    submit() {
      this.physician.name = this.physician.fName + " " + this.physician.lName;
      this.physician.associatedUser = this.users.filter(e => {
        return e.srNo == this.physician.associatedUser;
      });
      if (this.physician.associatedUser.length == 0)
        this.physician.associatedUser = this.users.filter(e => {
          return e.name == " ";
        });
      this.$validator.validateAll()
        .then(valid => {
          if (valid) {
            this.$emit("submit", this.physician);
            this.error = "";
          }
          else
            this.error = "Please fill in all fields.";
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-axis-logo {
  width: 60px;
}

.inputField {
  max-width: 400px;
}

.error{
  text-align: center;
}
</style>